var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnNavClose = function SvgIcnBtnNavClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3524 4.53745C5.11808 4.30314 4.73818 4.30314 4.50387 4.53745C4.26955 4.77177 4.26956 5.15166 4.50387 5.38598L11.1723 12.0544L4.53775 18.6889C4.30344 18.9232 4.30344 19.3031 4.53775 19.5374C4.77207 19.7718 5.15197 19.7718 5.38628 19.5374L12.0208 12.9029L18.6553 19.5374C18.8897 19.7718 19.2696 19.7718 19.5039 19.5374C19.7382 19.3031 19.7382 18.9232 19.5039 18.6889L12.8693 12.0544L19.5378 5.38598C19.7721 5.15166 19.7721 4.77176 19.5378 4.53745C19.3034 4.30314 18.9235 4.30314 18.6892 4.53745L12.0208 11.2059L5.3524 4.53745Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnNavClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_nav_close.962d07dc.svg";
export { ForwardRef as ReactComponent };